import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";
import { clearNotification } from "./notificationsSlice";
import { useIntl } from "react-intl";

const Notifier = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications);
  const intl = useIntl();

  useEffect(() => {
    if (notifications.notifications.length > 0) {
      const {
        id,
        type,
        message: body,
        title,
        extra_data,
      } = notifications.notifications[0];

      const isServerError = body?.name === "Error";
      const localizedMessage = intl.formatMessage({
        id: `app.notifications.${isServerError ? body?.name : body}`,
        defaultMessage: body,
      });
      const localizedTitle = intl.formatMessage({
        id: `app.notifications.${title}`,
      });
      if (type === "success") {
        message[type](localizedMessage);
      } else {
        message[type](
          `${localizedTitle}: ${localizedMessage}${
            extra_data ? ` ${extra_data}` : ""
          }`,
          4
        );
      }
      dispatch(clearNotification(id));
    }
  }, [dispatch, intl, notifications.notifications]);

  return null;
};

export default Notifier;
